<script setup lang="ts">
  import { formatCurrency } from "@/lib/utils.ts"
  import Button from "@/components/ui/button/Button.vue"
  import { Card, CardTitle } from "@/components/ui/card"
  import { Divider } from "@/components/ui/divider"

  const props = defineProps<{
    cardTitle: string
    monthlyEstimate: number
    annualEstimate: number
    selectTariff: () => void
  }>()
</script>

<template>
  <Card class="items-start justify-center gap-4">
    <CardTitle>{{ props.cardTitle }}</CardTitle>
    <Divider class="self-stretch" orientation="horizontal" />
    <div>
      <p class="flex items-baseline">
        <span class="h2">{{ formatCurrency(props.monthlyEstimate) }}</span>
        <span class="body-text ml-2">monthly estimate</span>
      </p>
      <p class="flex items-baseline">
        <span class="h3">{{ formatCurrency(props.annualEstimate) }}</span>
        <span class="body-text ml-2">annual estimate</span>
      </p>
    </div>
    <Divider orientation="horizontal" />
    <Button variant="tonal" size="md" @click="selectTariff">
      Select Tariff
    </Button>
  </Card>
</template>
